module.exports = __webpack_public_path__ + "img/Hungary.a2b26e53.svg";